/*
 * Copyright (c) 2023 Trimble Inc. All rights reserved.
 */

import Grid from '@mui/material/Grid';
import { Theme } from '@mui/material';
import { withStyles } from '@mui/styles';
import * as React from 'react';
import { categories, Category, CategoryType } from '../common/Categories';
import { getAllRoles, getAllServiceLevels } from '../common/common';
import DataTable from './DataTable';
interface Props {
  classes?: any;
}
const styles = (theme: Theme) => ({
  table: {
    width: '100%',
    padding: '12px'
  }
});

class UserTable extends React.Component<Props, {}>{
  componentDidMount() {
    getAllRoles();
    getAllServiceLevels();
  }
  render() {
    const { classes}=this.props;
    const useradmincategory = categories.find(
      (category: Category) => {
        return category.id === 6 && category.type === CategoryType.User;
      }
    );
    return (
      <Grid className={classes.table}>
        {<DataTable
          selectedCategory={useradmincategory}
        />}
      </Grid>
    );
  }
}

export default withStyles(styles)(UserTable);
